export default __webpack_public_path__ + "static/media/configurations.71a6bfe9.svg";